import styled from "styled-components";
import themes from "@/styles/themes";
import Icon from '@mdi/react';
import {mdiCheck, mdiChevronDown} from '@mdi/js';
import {useDispatch, useSelector} from "react-redux";
import {GET_PAYMENT_STEP, GET_USER_STEP, GET_USER_TAB, SET_USER_STEP} from "@/store/slices/appSlice";

import Events from "@/utils/Events";
import { useCookies } from "react-cookie";
import { GET_OFFER, GET_OFFER_TYPE } from "@/store/slices/offerSlice";
import { ReactNode, useMemo } from "react";
import { GET_USER_ADDRESS, SET_USER } from "@/store/slices/userSlice";


const ButtonArcodionShowHidden = styled.button`
  cursor: pointer;
  float: right;
  border: none;
  background: none;
  color: ${themes.estadao};
`
const AcordionHeader = styled.div`
  font-size: 18px;
  color: ${themes.estadao};
  cursor: pointer;
  padding: 8px 0;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  transition: 0.4s;
  border-top: 1px solid ${themes.estadao};
  margin: 10px 0;
  position: relative;
  display: flex;
  align-items: center;
  background: none;

  &.next{
    padding: 8px 0 25px 0;
    color: ${themes.grey};
    border-top: 1px solid ${themes.grey};
    
    span.step{
      background-color: ${themes.white};
      color: ${themes.grey};
      border: 1px solid ${themes.grey};
    }

    ${ButtonArcodionShowHidden} {
      svg {
        color: ${themes.grey};
      }
    }
  }

  &.finished {
    color: ${themes.grey};
    border-top: 1px solid ${themes.grey};

    ${ButtonArcodionShowHidden} {
      svg {
        color: ${themes.grey};
      }
    }
  }

  span.step {
    background: ${themes.estadao};
    border-radius: 100px;
    color: white;
    width: 30px;
    height: 30px;
    display: inline-block;
    text-align: center;
    line-height: 30px;
    margin-right: 10px;
    font-size: 14px;
    &.finished {
      background: ${themes.green};

      svg {
        width: 20px !important;
        height: 30px !important;
        color: white;
      }
    }
  }

  .active, .accordion:hover {
    background-color: #ccc;
  }
`
const ArcordionTitle = styled.div`
display: inline-flex;
flex-grow: 1;
span{
font-weight: 600;
}
`
const PositionSubtitle = styled.div `
color: #757582;
font-size: 12px;
font-weight: 700;
`
const ArcordionPanel = styled.div`
  padding: 0;
  display: none;
  overflow: hidden;
  border-bottom: 1px solid ${themes.estadao};
  margin-bottom: 19px;
  &.show-hidden {
    display: block;
  }
`

export interface IStepAcordionsProps{
  page?: string
  step: string
  title: string
  subtitle?: string
  children: ReactNode
}

export default function StepAcordions(parent: IStepAcordionsProps) {
    const current = useSelector(GET_USER_STEP)
    const dispatch = useDispatch()
    const oferta = useSelector(GET_OFFER)
    const offer_type = useSelector(GET_OFFER_TYPE)
    const payment_step = useSelector(GET_PAYMENT_STEP)
    const user_tab = useSelector(GET_USER_TAB)
    const events = new Events()
    const cookies = useCookies()[0];
    
    function setStap(idx: number) {
        if (current === 2) {
          if (parseInt(parent.step) === 1) {
            if (parent.page === "digital") {
              events.trigger("pagamento_cartao_voltar_para_identificacao", { offer_type })
            }
            // if (parent.page === "impresso") {
            //   events.trigger("entrega_voltar_para_identificacao", { offer_type })
            // }
            if (parent.page === "cortesia") {
              events.trigger("cortesia_voltar_para_identificacao", { offer_type })
            }
  
            if (parent.page === "voucher") {
              events.trigger("voucher_voltar_para_identificacao", { offer_type })
            }
          }
        }
        if (current === 3) {
  
          if (parseInt(parent.step) === 2) {
            if (parent.page === "impresso") {
              // events.trigger("pagamento_voltar_para_entrega", { offer_type })
            }
          }
          if (parseInt(parent.step) === 1) {
            if (parent.page === "digital") {
              // events.trigger("pagamento_cartao_voltar_para_identificacao", { offer_type })
            }
          }
      }

      if(current > idx){
        dispatch(SET_USER_STEP(idx))
      }


    }
    if (current === 1 && cookies.OESP_INFO && user_tab === 2) {
      events.trigger("identificacao_logado_visualizado", { offer_type })
    }
    if (current === 2) {
      if(parent.page === 'digital' && payment_step === 0){
        events.trigger("pagamento_cartao_visualizado", { offer_type })
      }
      if(parent.page === 'impresso'){
        events.trigger("endereco_entrega", { offer_type })
      }
      if(oferta?.has_partner){
        if(parent.page === "voucher" && oferta.valor && oferta.valor.loading === undefined){
          events.trigger("voucher_visualizado", { offer_type })
        }
      }

      if (parent.page === "cortesia") {
        events.trigger("cortesia_visualizado", { offer_type })
      }
    }

    if(current === 3){
      if(parent.page === "impresso" && payment_step === 0){
        events.trigger("pagamento_cartao_visualizado", { offer_type })
      }
      if(parent.page === "impresso" && payment_step === 1){
        events.trigger("pagamento_debito_visualizado", {offer_type})
      }
    }

    let step = '';
    if (parseInt(parent.step) === current) {
        step = 'show-hidden'
    }
    else if (current > parseInt(parent.step)) {
        step = 'finished'
    } else {
        step = 'next'
    }
    return (
        <div key={parent.step} className={step}>
            <AcordionHeader className={step} onClick={()=>setStap(parseInt(parent.step))}>
                {step !== 'finished' && <span className={'step'}>{parent.step}</span>}
                {step === 'finished' && <span className={'step ' + step}>
                <Icon path={mdiCheck} size={1}/>
                </span>}
                  <ArcordionTitle>
                      <span>{parent.title}</span>
                  </ArcordionTitle>

                <ButtonArcodionShowHidden className={step}>
                {parent.title === "Identificação"&&<Icon path={mdiChevronDown} size={1}/>}
                </ButtonArcodionShowHidden>

            </AcordionHeader>
            {parent.subtitle && step === 'finished' &&<PositionSubtitle style={{margin: '-14px 0px 17px 41px'}}>{parent.subtitle}</PositionSubtitle>}
            <ArcordionPanel className={step} style={current == 1 ? {borderBottom: 'none'}:{}}>
                {parent.children}
            </ArcordionPanel>
        </div>
    )
}
